export default "__VITE_ASSET__CmDWKMb2__"